import questionsApi from './api/questionsApi';
import config from "../config";

export const INFO_LIST = 'questions/INFOLIST';
export const QUESTIONS_LIST = 'questions/QUESTIONSLIST';


const initialState = {

}

export default (state = initialState, action) => {
	switch (action.type) {

		case INFO_LIST:
			return {
				...state,
				infoData: action.payload
			};

		case QUESTIONS_LIST:
			return {
				...state,
				questionsData: action.payload
			}

		default:
			return state;

	}
};

export const infoList = (payload) => {
	return dispatch => {
		return questionsApi.InfoList().then(data => {

			dispatch({
				type: INFO_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const infoSubmit = (payload) => {
	return dispatch => {
		return questionsApi.InfoSubmit(payload).then(data => {
			return data;
		}).catch(error => {
			throw (error)
		})
	}
}

export const dreamSubmit = (payload) => {
	return dispatch => {
		return questionsApi.DreamSubmit(payload).then(data => {
			return data;
		}).catch(error => {
			throw (error)
		})
	}
}


export const questionsList = (payload) => {
	return dispatch => {
		return questionsApi.QuestionsList().then(data => {
			dispatch({
				type: QUESTIONS_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		})
	}
}

export const questionsSubmit = (payload) => {
	return dispatch => {
		console.log(payload)
		return questionsApi.QuestionsSubmit(payload).then(data => {
			return data;
		}).catch(error => {
			throw (error)
		})
	}
}
